import { INavSearchUxXP } from "@faire/web-api/indigofair/seo/INavSearchUxXP";
import { NAV_SEARCH_UX_240826 } from "@faire/web-api/indigofair/settings/NAV_SEARCH_UX_240826";
import { route as discoverRoute } from "@faire/web-api/routes/discover/searchTerm";
import { route as homeRoute } from "@faire/web-api/routes/root";
import { removeLocaleFromUrl } from "@faire/web/ui/routing/util";
import { useMemo } from "react";
import { matchPath } from "react-router-dom";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

import { useZustandLocation } from "../app/_lib/routing/useZustandLocation";

/**
 * `isTreatment` represents the base behaviour of the XP: a search bar which hides when scrolling down.
 * `isStickyVariant` and `isBannerlessVariant` are extensions of the base behaviour, with
 * `isStickyVariant` disabling the hiding of the search bar and `isBannerlessVariant` removing the banner + adding a new placeholder copy.
 */
export const useSettingNavSearchUX = (): {
  isTreatment: boolean;
  isStickyVariant: boolean;
  isBannerlessVariant: boolean;
} => {
  const setting = useSetting(
    NAV_SEARCH_UX_240826,
    INavSearchUxXP.Bucket.BUCKET_UNKNOWN
  );
  const { pathname } = useZustandLocation((state) => state.pathname);

  const isWhitelistedPage: boolean = useMemo(() => {
    const whitelist = [
      {
        path: homeRoute,
        exact: true,
      },
      {
        path: discoverRoute,
        exact: true,
      },
    ];
    return whitelist.some(
      (path) => matchPath(removeLocaleFromUrl(pathname), path) !== null
    );
  }, [pathname]);

  return {
    isTreatment:
      setting !== INavSearchUxXP.Bucket.CONTROL &&
      setting !== INavSearchUxXP.Bucket.BUCKET_UNKNOWN &&
      isWhitelistedPage,
    isStickyVariant:
      setting === INavSearchUxXP.Bucket.VARIANT_B && isWhitelistedPage,
    isBannerlessVariant:
      setting === INavSearchUxXP.Bucket.VARIANT_C && isWhitelistedPage,
  };
};

export const useAssignSettingNavSearchUX = () =>
  useAssignSetting(NAV_SEARCH_UX_240826);
